export const environment = {
  production: false,
  coreAppUrl: 'http://localhost:4200',
  adminAppUrl: 'http://localhost:4201',
  apiUrl: 'http://localhost:8080',
  authApiUrl: 'http://localhost:8080/auth',
  blogApiUrl: 'http://localhost:8080/blogs',
  enableDebug: true,
  version: '1.0.0-dev',
  appName: 'Admin Panel',
  features: {
    enableAnalytics: false,
    enableLogging: true,
  },
  appTitleSuffix: 'DevSpace',
  // Logto Authentication Config
  logtoEndpoint: 'https://t5m0nl.logto.app',
  logtoAppId: '2cdj7khkc56rm9y9zhrjk', // SPA app (public client)
  apiResource: 'http://localhost:8080', // API resource for JWT tokens
};
